"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberEnum = exports.NumberNode = void 0;
const __1 = require("..");
const DataModel_1 = require("../model/DataModel");
const Node_1 = require("./Node");
const NumberNode = (config) => {
    var _a, _b, _c;
    const integer = (config === null || config === void 0 ? void 0 : config.color) ? true : (_a = config === null || config === void 0 ? void 0 : config.integer) !== null && _a !== void 0 ? _a : false;
    const min = (config === null || config === void 0 ? void 0 : config.color) ? 0 : (_b = config === null || config === void 0 ? void 0 : config.min) !== null && _b !== void 0 ? _b : -Infinity;
    const max = (config === null || config === void 0 ? void 0 : config.color) ? 16777215 : (_c = config === null || config === void 0 ? void 0 : config.max) !== null && _c !== void 0 ? _c : Infinity;
    const between = (config === null || config === void 0 ? void 0 : config.min) !== undefined && (config === null || config === void 0 ? void 0 : config.max) !== undefined;
    return {
        ...Node_1.Base,
        type: () => 'number',
        default: () => min > 0 ? min : 0,
        validate(path, value, errors, options) {
            if (options.loose && typeof value !== 'number') {
                value = options.wrapLists ? DataModel_1.DataModel.wrapLists(this.default()) : this.default();
            }
            if (typeof value !== 'number') {
                errors.add(path, 'error.expected_number');
            }
            else if (integer && !Number.isInteger(value)) {
                errors.add(path, 'error.expected_integer');
            }
            else if (between && (value < min || value > max)) {
                errors.add(path, 'error.invalid_number_range.between', value, min, max);
            }
            else if (value < min) {
                errors.add(path, 'error.invalid_number_range.smaller', value, min);
            }
            else if (value > max) {
                errors.add(path, 'error.invalid_number_range.larger', value, max);
            }
            return value;
        },
        hook(hook, path, ...args) {
            var _a;
            return ((_a = hook.number) !== null && _a !== void 0 ? _a : hook.base).call(hook, { node: this, integer, min, max, between, config: config !== null && config !== void 0 ? config : {} }, path, ...args);
        }
    };
};
exports.NumberNode = NumberNode;
const NumberEnum = ({ integer, values }) => (0, __1.Mod)((0, exports.NumberNode)({ integer }), node => ({
    validate: (path, value, errors, options) => {
        value = node.validate(path, value, errors, options);
        if (!values.includes(value)) {
            errors.add(path, 'error.invalid_number_enum', values.join(', '));
        }
        return value;
    }
}));
exports.NumberEnum = NumberEnum;
